import type { BulkEligibility, BulkFieldEligibility } from "../DiscoverGamesBulkUpdateModal";

/** Turn the raw eligibility API response into `Set`s the modal/apply path can query in O(1). */
export function adaptEligibilityResponse(
	selectedCount: number,
	isLoading: boolean,
	raw: {
		total?: number;
		clubManager?: { eligible?: number[]; ineligible?: number[] };
		contentManager?: { eligible?: number[]; ineligible?: number[] };
		assignee?: { eligible?: number[]; ineligible?: number[] };
		priority?: { eligible?: number[]; ineligible?: number[] };
		gameStatus?: { eligible?: number[]; ineligible?: number[] };
	} | undefined,
): BulkEligibility {
	const toField = (field: { eligible?: number[]; ineligible?: number[] } | undefined): BulkFieldEligibility => ({
		eligible: new Set<number>(
			Array.isArray(field?.eligible) ? field!.eligible.map((n) => Number(n)) : [],
		),
		ineligible: new Set<number>(
			Array.isArray(field?.ineligible) ? field!.ineligible.map((n) => Number(n)) : [],
		),
	});

	if (!raw) {
		const empty: BulkFieldEligibility = { eligible: new Set(), ineligible: new Set() };
		return {
			total: selectedCount,
			isLoading,
			hasData: false,
			clubManager: empty,
			contentManager: empty,
			assignee: empty,
			priority: empty,
			gameStatus: empty,
		};
	}

	return {
		total: typeof raw.total === "number" ? raw.total : selectedCount,
		isLoading,
		hasData: true,
		clubManager: toField(raw.clubManager),
		contentManager: toField(raw.contentManager),
		assignee: toField(raw.assignee),
		priority: toField(raw.priority),
		gameStatus: toField(raw.gameStatus),
	};
}
